import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'
import { footerEn /* footerAr*/ } from '../data/footer'
import { computingLab, navigationTop, navigationButtom } from '../params'




const HpcDetailPage = ({ updateLang }) => {
    const [htmlContent, setHtmlContent] = React.useState('');
    const [dynamicRoutes, setDynamicRoutes] = useState(computingLab);

    document.title = 'Research Computing Core Group';
    const headerData = {
        title: 'Research Computing Core Group',
        crumb: [
            { link: '//', text: 'Home' },
            { link: '/', text: 'Research' },
            { text: 'Research Computing Core Group' },
        ],
        applicationLinks: [
            { text: 'Apply now', class: 'bordred', link: 'https://hbkuqa.elluciancrmrecruit.com/Apply/Account/Login?ReturnUrl=%2fApply' },
        ],
       // navigationTop: computingLab, // Add this line to include main menu items
        navigationButtom: computingLab // Add this if you want bottom navigation as well
    };

    useEffect(() => {
        fetch('https://www.hbku.edu.qa/en/api/corelab.json?lab=computing')
            .then(response => response.json())
            .then(data => {
                const filteredData = data.filter(
                    item => item.short_page_type_name === 'hpc'
                );
                if (filteredData.length > 0 && filteredData[0].body_1?.value) {
                    setHtmlContent(filteredData[0].body_1.value);
                }
            })
            .catch(error => {
                console.error('API error:', error);
            });
    }, []);

    return (
        <>
            <Navigation
                {...headerData}
                // computingLab={[]}
                updateLang={updateLang}
            />
            {/* <NewsBanner {...HeaderBanner} coreLab={true} /> */}
            <section className='m-wrap pb-0'>
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </section>
            <Footer {...footerEn} />
        </>
    );
};

export default HpcDetailPage;
